export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8013.478df808.jpg";